import { render, staticRenderFns } from "./ModelosDeLiquidacion.vue?vue&type=template&id=fb837c70"
import script from "./ModelosDeLiquidacion.vue?vue&type=script&lang=js"
export * from "./ModelosDeLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports